export enum MenuType {
  PAGE = "PAGE",
  CATEGORY = "CATEGORY",
  CUSTOM = "CUSTOM",
}
